import React, { useEffect, useState, useMemo, useCallback } from "react";
import Navbar from "../../components/admin/layout/navbar";
import Sidebar from "../../components/admin/layout/sidebar";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { CgSpinner } from "react-icons/cg";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { db } from "../../firebase";

/* ================= CUSTOM TABLE STYLE ================= */
const customStyles = {
  rows: {
    style: {
      minHeight: "55px",
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      backgroundColor: "#413b3b",
      color: "white",
      fontSize: "14px",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      borderRight: "1px solid #eaeaea",
    },
  },
};

export default function AdminTruevalue() {
  const [active, setActive] = useState(true);
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleActive = () => setActive(!active);

  // 🔥 Fetch Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const q = query(
          collection(db, "truevalue"),
          orderBy("timestamp", "desc"),
        );

        const snapshot = await getDocs(q);

        const list = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          timestamp: doc.data().timestamp?.toDate()?.toLocaleString() || "",
        }));

        setData(list);
        setFilteredData(list);
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch leads");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // 🔍 Search Filter
  useEffect(() => {
    const result = data.filter((item) =>
      [item.name, item.email, item.phone]
        .filter(Boolean)
        .some((field) => field.toLowerCase().includes(search.toLowerCase())),
    );

    setFilteredData(result);
  }, [search, data]);

  // 📥 CSV Export
  const downloadCSV = useCallback((array) => {
    if (!array.length) return;

    const keys = Object.keys(array[0]);
    const csv = [
      keys.join(","),
      ...array.map((row) => keys.map((k) => `"${row[k] ?? ""}"`).join(",")),
    ].join("\n");

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "leads.csv";
    link.click();

    URL.revokeObjectURL(url);
  }, []);

  const actionsMemo = useMemo(() => {
    return (
      <button
        onClick={() => downloadCSV(data)}
        className="bg-green-600 z-50 text-white rounded px-5 py-1.5 text-sm"
      >
        Export Data
      </button>
    );
  }, [downloadCSV, data]);

  const columns = [
    // { name: "Id", selector: (row) => row.id },
    {
      name: "Form Type",
      selector: (row) => <p className=" capitalize">{row.formType}</p> || "-",
    },
    { name: "Name", selector: (row) => row.name || "-" },
    { name: "Email", selector: (row) => row.email || "-" },
    { name: "Phone", selector: (row) => row.phone || "-" },
    { name: "Model", selector: (row) => row.model || "-" },
    { name: "Year", selector: (row) => row.year || "-" },
    { name: "Owner", selector: (row) => row.owner || "-" },
    { name: "Kms", selector: (row) => row.km || "-" },
    { name: "Fuel", selector: (row) => row.fuel || "-" },
    {
      name: "Date",
      selector: (row) => row.timestamp || "-",
    },
  ];

  return (
    <div className="flex h-screen">
      <Sidebar active={active} />

      <div className="flex-auto bg-gray-50 overflow-auto">
        <Navbar handleActive={handleActive} />

        <div className="mx-5 mt-5">
          {loading ? (
            <CgSpinner
              className="animate-spin mx-auto"
              size={50}
              color="#7e22ce"
            />
          ) : (
            <DataTable
              title="All Truevalue Leads"
              columns={columns}
              data={filteredData}
              pagination
              fixedHeader
              fixedHeaderScrollHeight="100vh"
              highlightOnHover
              selectableRows
              subHeader
              customStyles={customStyles}
              actions={actionsMemo}
              subHeaderComponent={
                <SearchComponent search={search} setSearch={setSearch} />
              }
            />
          )}
        </div>
      </div>
    </div>
  );
}
const SearchComponent = ({ search, setSearch }) => (
  <div className="flex justify-center">
    <input
      className="border-2 rounded mb-3 py-2 px-4 focus:outline-none"
      type="text"
      placeholder="Search by name, phone or email"
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      style={{ width: "300px" }}
    />
  </div>
);
